// import Vue from 'vue';
import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import defaultDisplayContent from '@/defaultDisplayContent/htmlDisplay';
// Vue.use(Vuex);

function initialState () {
  return {
    loading: true,
    agency: null,
    user: {
      uuid: null,
      thumbnail: null,
      gender: null,
      firstname: null,
      lastname: null,
      birth_date: null,
      email: null,
      mobilephone: null,
      street_number: null,
      street_name: null,
      address2: null,
      zip_code: null,
      town: null,
      country: null,
      nationality: null,
      newsletters: {},
      contexts: [],
      contacts: [],
      language: null,
      is_eligible_referrer: false,
      emergency_contacts: [],
      helloId: null,
      iresa_ids: [],
      externalContextsData: {},
      isCommonCustomer: null
    },
    impersonateData: null,
    centers: [],
    wallets: [],
    contacts: [],
    allowedLanguages: ['fr'],
    selectedLanguage: null,
    siteConfiguration: []
  };
}

function sanitizeInput (data, filteredKeys) {
  return filteredKeys.reduce((obj, key) => ({ ...obj, [key]: data[key] }), {});
}

export default createStore({
  plugins: [createPersistedState({
    paths: [
      'user',
      'contacts',
      'impersonateData'
    ]
  })],
  state: initialState,
  mutations: {
    setUser (state, data) {
      state.user = sanitizeInput(data, Object.keys(initialState().user));
    },
    setContacts (state, data) {
      state.contacts = data;
    },
    setWallets (state, data) {
      state.wallets = data;
    },
    setCenters (state, data) {
      state.centers = data;
    },
    setLoading (state, data) {
      state.loading = data;
    },
    setSelectedLanguage (state, data) {
      state.selectedLanguage = data;
    },
    setSiteConfiguration (state, data) {
      state.siteConfiguration = data;
    },
    setImpersonateData (state, data) {
      state.impersonateData = data;
    },
    setAgency (state, data) {
      state.agency = data;
    },
    deleteUser (state) {
      state.user = null;
    }
  },
  actions: {},
  modules: {},
  getters: {
    contacts: state => state.contacts,
    getSiteUrl: (state, getter) => () => {
      const { sitePreroute, siteUrl } = (state.siteConfiguration && state.siteConfiguration.data) ? state.siteConfiguration.data : {};

      let url = '/';

      if (sitePreroute) url += `${sitePreroute}/`;

      if (siteUrl) url += `${siteUrl}/`;

      return url;
    },
    getSiteConfiguration: (state, getter) => (type, section) => {
      // DISPLAY CONTENT

      let data = [];
      const configuration = (state.siteConfiguration && state.siteConfiguration.data) ? state.siteConfiguration.data : {};

      if (configuration && !Object.keys(configuration).length) {
        configuration.type = 'firstInteration';
      }

      let findData = [];

      if (configuration.hasOwnProperty(type) && configuration[type]) {
        findData = configuration[type].reduce((pv, cv) => {
          if (cv.display_content_localization === section || typeof cv === 'string') {
            if (!cv.hasOwnProperty('display_content_language') || (cv.display_content_language && cv.display_content_language === getter.getLanguage)) {
              pv.push(cv);
            }
          }

          return pv;
        }, []);
      } else if (defaultDisplayContent.hasOwnProperty(section)) {
        data.push(defaultDisplayContent[section]);
      }

      data = [...data, ...findData];

      return data;
    },
    getSelectedLanguage: state => state.selectedLanguage,
    getLanguage: state => {
      if (state.selectedLanguage) {
        return state.selectedLanguage;
      }

      // // get browser language
      // let locale = window.navigator.userLanguage || window.navigator.language;

      // // validade user language
      // if (state.user && state.user.language) {
      //   locale = state.user.language;
      // }

      // // transform language
      // if (locale && locale.includes('en')) {
      //   locale = 'en';
      // }

      // if (locale && locale.includes('fr')) {
      //   locale = 'fr';
      // }

      return 'fr';
    }
  }
});
